import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AssetsCalendarFr } from 'src/app/shared/models/calendar-fr';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  constructor(public http: HttpClient) {}

  // Locale getJSON for calendar
  public getCalendartranslate(locale: string): Observable<AssetsCalendarFr> {
    return this.http.get<AssetsCalendarFr>(`assets/calendar/calendar${this.capitalizeFirstLetter(locale)}.json`);
  }

  capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
